import type { Dict } from "../types";

const en: Dict = {
  city: "city",
  pick: "Listen",
  picking: "Looking…",
  here: "My location",
  here_name: "Here",
  reading: "Reading the weather…",
  queue: "Up next",
  contUp: "plays on and follows the weather",
  cities: "Where it differs now",
  citiesNote: "cities whose weather is furthest from yours",
  heard: "{v} heard",
  feels: "feels like",
  wind: "wind",
  cloud: "cloud",
  precip: "precip",
  pressure: "pressure",
  kmh: "km/h",
  mmh: "mm/h",
  hpa: "hPa",
  themeLight: "Light theme",
  themeDark: "Dark theme",
  themeSystem: "Follow system",
  play: "Play",
  pause: "Pause",
  prevTrack: "Previous",
  nextTrack: "Next",
  volume: "Volume",
  installTitle: "Add to home screen",
  installWhy: "opens full screen and works without the browser",
  installYes: "Install",
  installNo: "Later",
  looping: "Jamendo is not responding — looping the current set",
  retrying: "Trying again in {v}s…",
  notFound: "City “{v}” not found.",
  didYouMean: "Did you mean:",
  noGeo: "This browser gives no geolocation.",
  geoDenied: "Geolocation was not allowed.",
  failed: "That did not work.",
  noCandidates: "No candidates found — try another city.",
  geocodeDown: "Geocoding is unavailable.",
  errThrottled: "Jamendo is not responding — too many requests. Trying again.",
  errEmpty: "Jamendo returned nothing this time — trying again.",
  errNoKey: "The Jamendo key is missing — check the app configuration.",
  errHttp: "Jamendo is unavailable.",
  errApi: "Jamendo returned an error.",
  viaArchive: "Jamendo is silent — playing from the Internet Archive.",
  byProfile: "on the overall profile",
  credits: "Music by Jamendo, tracks under Creative Commons licences, rights with the artists. Weather by Open-Meteo, CC BY 4.0. Place search by OpenStreetMap contributors, ODbL.",
  grey_streak: "{v} grey days in a row",
  temp_drop: "{v}° colder than yesterday",
  temp_rise: "{v}° warmer than yesterday",
  anomaly_warm: "warmer than usual for this week",
  anomaly_cold: "colder than usual for this week",
  hot: "hot, {v}°",
  warm: "warm, {v}°",
  cool: "cool, {v}°",
  cold: "cold, {v}°",
  frost: "freezing, {v}°",
  clear_day: "clear sky",
  clear_night: "clear night",
  overcast: "fully overcast",
  snow: "snowing",
  heavy_rain: "heavy rain, {v} mm/h",
  rain: "rain {v} mm/h",
  rain_wet: "wet",
  fog: "fog",
  storm: "storm, {v} km/h",
  windy: "windy, {v} km/h",
  night: "night",
  golden_hour: "{v} min to sunset",
  pressure_falling: "pressure falling {v} hPa",
  pressure_rising: "pressure rising {v} hPa",
  clearing: "clearing soon",
  worsening: "rain by evening, {v}%",
  c_blizzard: "snow driven by wind — a blizzard",
  c_night_rain: "rain in the dark",
  c_long_grey: "a long grey spell in the cold",
  c_blaze: "clear blazing heat",
  c_bright_frost: "bright frost",
  c_night_storm: "a storm in the night",
  c_foul: "rain driven by wind — foul weather",
  c_cold_fog: "cold fog",
  c_golden: "a clear sunset",
  c_odd_warm: "warmth out of season",
  c_front: "a front moving in under full cloud",
  c_turn_cold: "turning cold with rain",
  "speed:verylow": "very slow",
  "speed:low": "slow",
  "speed:medium": "mid tempo",
  "speed:high": "fast",
  "speed:veryhigh": "very fast",
  "vocal:instrumental": "instrumental",
  "vocal:vocal": "vocals",
  "acoustic:acoustic": "acoustic",
  "acoustic:electric": "electric",
};

export default en;
